import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Clear as ClearIcon } from "@mui/icons-material";

const FormDialog = ({ open, onClose, title, children, onSubmit, saving, isMobile, disabled }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isMobile}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose} size="small">
            <ClearIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        {children}
      </DialogContent>
      <DialogActions sx={{ p: 2, flexDirection: isMobile ? "column" : "row", gap: 1 }}>
        <Button onClick={onClose} fullWidth={isMobile} disabled={saving}>Cancel</Button>
        <Button onClick={onSubmit} variant="contained" fullWidth={isMobile} disabled={saving || disabled}>
          {saving ? (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CircularProgress size={16} color="inherit" />
              {title.includes("Edit") ? "Updating..." : "Saving..."}
            </Box>
          ) : (title.includes("Edit") ? "Update" : "Save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FormDialog;
